import tinymce from 'tinymce/tinymce';

import 'tinymce/themes/silver';

import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/imagetools'

tinymce.init({
    selector: 'textarea#tinymce-editor',
    plugins: 'image, imagetools, wordcount, link, paste',
    toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image paste',
    images_upload_handler: uploadImages,
    height: '65vh',
    relative_urls: false,
    remove_script_host: false,
    convert_urls: true,
});

window.upload_url = null;
window.image_save_path = null;

function uploadImages(blobInfo, success, failure) {
    if (!upload_url) {
        failure('Missing Upload Url');
        return;
    }

    if (!image_save_path) {
        failure('Save directory not select')
    }

    window.onbeforeunload = function () {
        $.ajax({
            url: '/photos/delete?session=1',
            method: 'DELETE',
            contentType: false,
            processData: false
        });
    };

    let formData = new FormData();
    formData.append('image', blobInfo.blob());
    formData.append('path', window.image_save_path);

    let reader = new FileReader();

    reader.onload = function (e) {
        $.ajax({
            url: upload_url,
            method: 'POST',
            mode: 'textarea',
            data: formData,
            contentType: false,
            processData: false,
            success: function (response) {
                window.editor_photos.push(response.filePath);

                success(response.link)
            },
            error: function (error) {
                failure(error)
            }
        })
    };

    reader.onerror = function (e) {
        failure(e);
    };

    reader.readAsDataURL(blobInfo.blob());
}

